export default ['$rootScope', '$timeout', '$window', ($rootScope, $timeout, $window) => {
    const messageService = {};
    messageService.display = undefined;
    messageService.link = undefined;
    messageService.displaylink = undefined;
    messageService.linktext = undefined;
    messageService.displaylinktext = undefined;
    messageService.text = undefined;
    messageService.counter = undefined;
    messageService.class = undefined;
    messageService.timeout = undefined;

    $rootScope.$on("$locationChangeSuccess", function() {
      if (messageService.counter === 1){
        messageService.push();
      }
      else {
        messageService.counter--;
      }
    });

    messageService.success = function(text, linkparams = null, counter=1) {
        messageService.alerttype = 'alert--success';
        messageService.updateText(text, counter);
        if (linkparams) messageService.updateLink(linkparams[0], linkparams[1]);
    };

    messageService.failure = function(text, linkparams = null, counter=1) {
        messageService.alerttype = 'alert--fail';
        messageService.updateText(text, counter);
        if (linkparams) messageService.updateLink(linkparams[0], linkparams[1]);
    };

    messageService.updateText = function(text, counter){
        messageService.class = undefined;
        messageService.text = text;
        messageService.counter = counter;
        $window.scrollTo(0,0);
    };

    messageService.updateLink = function(link, linktext){
        messageService.link = link;
        messageService.linktext = `[ Edit this `+linktext+ ` ]`;
    };

    messageService.push = function (){
        messageService.class = undefined;
        messageService.display = (messageService.text ? messageService.text : undefined);
        messageService.displaylink = (messageService.link ? messageService.link : undefined);
        messageService.displaylinktext = (messageService.linktext ? messageService.linktext : undefined);
        messageService.reset();
    };

    messageService.reset = function() {
        messageService.text = undefined;
        messageService.link = undefined;
        messageService.linktext = undefined;
    };

    messageService.clear = function() {
        messageService.display = undefined;
        messageService.displaylink = undefined;
        messageService.displaylinktext = undefined;
    };

    messageService.autoClear = function() {
      if (messageService.timeout) {
        $timeout.cancel(messageService.timeout);
      }
      messageService.timeout = $timeout(() => {
        messageService.class = 'alert--remove';
        $timeout(() => {
          messageService.clear();
        }, 500);
      }, 3000);
    };

    messageService.formatError = function(field, error) {
        let message = '';

        switch ( field ) {
            case 'slug':
                message = 'The URL';
                break;
            default:
                message = `The ${field} field`;
        }

        if ( Array.isArray(error) ) {
            let messages = [];
            for ( let err of error ) {
                messages.push(messageService.switchError(err));
            }
            message += messages.join(',') + '.';
        } else {
            message += messageService.switchError(error) + '.';
        }

        return message;
    };

    messageService.switchError = function (error) {
        let message = '';

        switch( error ) {
            case 'required':
                message = ' is required';
                break;

            case 'conflict':
                message = ' is conflicting with another existing resource';
                break;

            case 'unique':
                message = ' needs to be unique; that value already exists';
                break;

            default:
                message = error;
        }

        return message;
    };

    return messageService;
}];


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/services/message.service.js